export default __webpack_public_path__ + "static/media/science-bg-small.98034834.webp";